import { HighRiskQuestionnaireType, VeriffMetadataType } from 'data/App/types'
import { TierType } from 'data/Auth/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getVeriffMetadata = () =>
  fetchApi<VeriffMetadataType>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/kyc/credentials/veriff')
  })

export const syncHighRisk = (body: HighRiskQuestionnaireType) =>
  fetchApi<VeriffMetadataType>({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl('nabu-gateway/kyc/questionnaire')
  })

export const syncVeriff = (body: { applicantId: string }) =>
  fetchApi<void>({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl('nabu-gateway/kyc/verifications')
  })

export const selectTier = (selectedTier: TierType) =>
  fetchApi<void>({
    auth: true,
    body: { selectedTier },
    method: 'POST',
    url: getApiUrl('nabu-gateway/kyc/tiers')
  })
